import { openAppointmentModal } from './modal-appointment-courses';

const contactsBtn = document.querySelector('.contacts-btn');

contactsBtn.addEventListener('click', openAppointmentModal);
